export default {
    loading: false,
    error: null,
    accessToken: null,
    refreshToken: null,
    user: {}
};
